import { useContext } from "react";
import { Users } from "src/context";
import { Processor } from "./Processor";

let state = null;

const IsEnabled = () => {
  const { userIntegrations } = useContext(Users);
  let active_integrations = userIntegrations ?? [];

  if (active_integrations.length === 0) return false;

  let check = active_integrations.filter((x) => x.id === 10);
  if (check.length > 0 && check?.[0]?.user_integrations === "active") {
    return true;
  }

  return false;
};

const getComponent = () => {
  return null;
};

const getConfig = () => {
  return {
    name: "convertkit",
    type: "marketing-tools",
    data: state,
  };
};

const updateData = (data) => {
  state = data;
};

const useProcessor = (user) => {
  return new Processor(user);
};

// check if exist in package or not
const isActiveInpackage = (_package) => {
  let config = _package?.options?.convertkit_config ?? {};
  return {
    convertkit: {
      active: Object.keys(config).length > 0 ? true : false,
      list: config?.convertkit_sequence ?? null,
      type: config?.type ?? null,
      tags: config?.convertkit_tags ? JSON.parse(config?.convertkit_tags) : [],
      tags_isrequired_list: false,
    },
  };
};

export default {
  IsEnabled,
  getComponent,
  getConfig,
  updateData,
  useProcessor,
  isActiveInpackage,
};
